import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';

const TitleAndDescription = () => {
    const {
        pageState: { pageConfig }
    } = usePageStore();

    return (
        <>
            <Grid item xs={12}>
                <Typography variant="h1">{pageConfig.title}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle1">{pageConfig.description}</Typography>
            </Grid>
        </>
    );
};

export default TitleAndDescription;
